export default {
  menu: 'Banks',
  title: 'Banks',

  general: {
    table: {
      header: {
        select: 'Select',
        row: 'Row',
        name: 'Name',
        cardNumber: 'Card number',
        accountNumber: 'Account number',
        balance: 'Inventory',
        delete: 'Delete',
        restore: 'Restore'
      }
    },

    labels: {
      name: 'Name',
      accountNumber: 'Account number',
      cardNumber: 'Card number',
      swiftCode: 'Swift code',
      shebaNumber: 'Number of IBAN',
      delete: 'Delete Bank',
      bank: 'Bank'
    },

    notifications: {
      insert: {
        success: 'New bank information successfully registered',
        error: 'Registering new bank information failed'
      },
      edit: {
        success: 'Bank information successfully edited',
        error: 'Editing bank information failed'
      },
      delete: {
        success: 'Deleting bank information successfully',
        error: 'Deleting bank information was accompanied by an error'
      },
      restore: {
        success: 'Bank information successfully restored',
        error: 'Retrieving bank information failed'
      },
      forceDelete: {
        success: 'Permanent deletion of bank information completed successfully',
        error: 'Permanent deletion of bank information was accompanied by an error'
      }
    },

    confirmations: {
      emptyBank: {
        title: 'No bank available',
        body: 'To create {name}, you need to connect a bank. Please create one first.'
      },
      delete: {
        title: 'Bank Deletion Confirmation',
        body: 'Are you sure you want to temporarily delete {bank}?'
      },
      forceDelete: {
        title: 'Bank Deletion Confirmation',
        body: 'Are you sure you want to delete {bank} permanently?'
      }
    },

    validators: {
      name: 'Bank name is not entered correctly',
      accountNumber: 'Account number is not entered correctly',
      cardNumber: 'Card number is not entered correctly',
      shebaNumber: 'IBAN number is not entered correctly'
    }
  },

  insert: {
    title: 'Add Bank'
  },

  list: {
    title: 'Banks'
  },

  trash: {
    title: 'Banks trash'
  },

  edit: {
    title: 'Edit Bank',
    dynamicTitle: 'Edit Bank {bank}'
  },

  bank: {
    title: 'Bank',
    dynamicTitle: 'Bank {bank}',

    importantData: {
      balance: 'inventory',
      openingBalance: 'Opening balance',
      transactionsCount: 'Number of transactions'
    },

    actions: {
      transactions: 'Bank transactions',
      logs: 'Time lines'
    }
  },

  transactions: {
    title: 'Bank Turnover',
    dynamicTitle: 'Bank Turnover {bank}',

    table: {
      header: {
        balance: 'Inventory',
        price: 'Amount',
        description: 'Documents',
        date: 'Date',
        docNumber: 'Document number'
      }
    }
  },

  logs: {
    title: 'Bank Logs'
  },

  openingBalance: {
    title: 'Bank opening balance',

    general: {
      table: {
        header: {
          row: 'Row',
          name: 'Bank name',
          price: 'Amount',
          delete: 'Delete'
        }
      },

      notifications: {
        locked: 'is the opening balance of the lock',
        negativeBalance: 'Bank cant get negative balance',

        isExisted: {
          message: 'This value is in the list',
          dynamicMessage: 'Bank {bank} is on the list'
        },

        insert: {
          success: 'The opening balance of the bank was successfully registered',
          error: 'The registration of the bank opening balance was accompanied by an error'
        },

        edit: {
          success: 'The first period of the bank in question was successfully updated',
          error: 'The update of the desired bank opening balance was accompanied by an error'
        },

        delete: {
          success: 'The deletion of the bank in question was successfully completed',
          error: 'The deletion of the desired bank opening balance was accompanied by an error'
        }
      }
    },

    insert: {
      title: 'The first addition of the bank course'
    },

    edit: {
      title: 'First edition of the bank period {bank}',

      confirmations: {
        delete: {
          title: 'Delete Confirmation',
          body: 'Are you sure you want to delete the first bank term?'
        }
      },

      labels: {
        price: 'Amount',
        delete: 'Delete first course'
      }
    }
  }
}
